<template>
  <div class="container">
    <div class="page-jobs">
      <div class="container" style="padding-bottom:100px;" >
        <p class="job-listings-mini-title">jobs at Gunspring</p>
        <p class="job-listings-title"  v-if="!isRenderDone">
          
        </p>
        <p class="job-listings-title"  v-else-if="data.length > 0">
          We're hiring for the following jobs at Gunspring
        </p>
        <p class="job-listings-title"  v-else>
          Sorry, there are no available positions at this time.
        </p>
        <a
          v-if="$store.getters.isAdmin"
          href="/admin/jobs/create"
          class="request-demo-button hero-button"
          >Create</a
        >
        <div class="job-listings" v-if="data.length > 0">
          <div v-for="job in data" :key="job.job_id" class="job-listing">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-6">
                <p class="job-listing-location">{{ job.location }}</p>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 text-right">
                <p class="job-listing-location">{{ getTime(job.created) }}</p>
              </div>
            </div>
             <router-link
            class="job-listing-title"
            :to="{ name: 'careersdetails',params: {job_id:job.job_id}}"
            >{{
              job.title
            }}</router-link
          >
            <p class="job-listing-location" v-if="$store.getters.isAdmin">
              # Job ID : {{ job.job_id }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [],
      isRenderDone: false,
    };
  },
  async mounted() {
    let res = await this.$store.dispatch("getJobAll");
    this.data = res.data;
    // change this to true indicate that starting data is ready.
    this.isRenderDone = true;
  },
  methods: {
    formatTime(time) {
      switch (typeof time) {
        case "number":
          break;
        case "string":
          time = +new Date(time);
          break;
        case "object":
          if (time.constructor === Date) time = time.getTime();
          break;
        default:
          time = +new Date();
      }
      var time_formats = [
        [60, "seconds", 1], // 60
        [120, "1 minute ago", "1 minute from now"], // 60*2
        [3600, "minutes", 60], // 60*60, 60
        [7200, "1 hour ago", "1 hour from now"], // 60*60*2
        [86400, "hours", 3600], // 60*60*24, 60*60
        [172800, "Yesterday", "Tomorrow"], // 60*60*24*2
        [604800, "days", 86400], // 60*60*24*7, 60*60*24
        [1209600, "Last week", "Next week"], // 60*60*24*7*4*2
        [2419200, "weeks", 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, "Last month", "Next month"], // 60*60*24*7*4*2
        [29030400, "months", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, "Last year", "Next year"], // 60*60*24*7*4*12*2
        [2903040000, "years", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, "Last century", "Next century"], // 60*60*24*7*4*12*100*2
        [58060800000, "centuries", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
      ];
      var seconds = (+new Date() - time) / 1000,
        token = "ago",
        list_choice = 1;

      if (seconds == 0) {
        return "Just now";
      }
      if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = "from now";
        list_choice = 2;
      }
      var i = 0,
        format;
      while ((format = time_formats[i++]))
        if (seconds < format[0]) {
          if (typeof format[2] == "string") return format[list_choice];
          else
            return (
              Math.floor(seconds / format[2]) + " " + format[1] + " " + token
            );
        }
      return time;
    },
    getTime(utcSeconds) {
      var setEpoch = new Date(0);
      var dateCreated = new Date(setEpoch.setUTCSeconds(utcSeconds));
      var dateNow = new Date();
      var difference = dateNow - dateCreated;
      return this.formatTime(new Date(Date.now() - difference));
    },
  },
};
</script>